module.exports = __webpack_public_path__ + "img/payt.63019ffb.png";